import React from "react";

export const VSpacer = ({height}) => (<div className={height ?? 'h-1'}></div>);
export const HSpacer = ({width}) => (<div className={width ?? 'w-1'}></div>);